<template>
  <compnent
    :is="tagName"
    :href="href"
    class="oct-add-circle"
    :class="[`oct-add-circle--${size}`]"
  >
    <oct-icon
      class="oct-add-circle__icon"
      icon="add"
    />

    <img
      :src="size === 'medium' ? image.standardResolution : image.lowResolution"
      class="oct-add-circle__image"
      v-if="image.lowResolution && image.lowResolution !== ''"
    />
  </compnent>
</template>

<script>
import OctIcon from '@/components/icon/OctIcon.vue'

export default {
  components: { OctIcon },
  name: 'OctAddCircle',
  props: {
    /** Image */
    image: {
      type: Object,
      default () {
        return {
          lowResolution: '',
          standardResolution: ''
        }
      }
    },
    /** Size [medium | small] */
    size: {
      type: String,
      default: 'medium'
    },
    /** Define click action */
    action: {
      type: Object,
      default () {
        return {
          href: ''
        }
      }
    },
  },
  computed: {
    /** Tag name */
    tagName () {
      return this.action && this.action.href && this.action.href !== '' ? 'a' : 'div'
    },
    /** href */
    href () {
      return this.action && this.action.href && this.action.href !== '' ? this.action.href : null
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-add-circle {
  position: relative;
  display: block;
  width: 100%;
  height: 0;
  padding-top: 100%;
  background-color: rgba(0,0,0,.05);
  border-radius: 50%;
  cursor: pointer;
  transition-duration: .2s;

  &:hover, &--hover {
    background-color: rgba(0,0,0,.1);
  }
}

.oct-add-circle__icon {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: oct-rem(46);
  height: oct-rem(46);
  stroke-width: oct-rem(2);

  .oct-add-circle--small & {
    width: oct-rem(46);
    height: oct-rem(46);
    stroke-width: oct-rem(2);
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  width: oct-rem(68);
  height: oct-rem(68);
  stroke-width: oct-rem(3);
}
}

.oct-add-circle__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
